import { useStore } from '@hooks/useStore'
import { observer } from 'mobx-react-lite'
import { ReactNode, useCallback, useContext, useEffect } from 'react'
import { useFormContext } from 'react-hook-form'
import { useBeforeUnload, useBlocker } from 'react-router-dom'
import { OvFormContext } from '../ov-form-provider/ov-form-provider'

export const OvFormNavigationBlocker = observer(({ children }: { children: ReactNode }) => {
  const { ui } = useStore()
  const { formState } = useFormContext()
  const { allowNavigationRef } = useContext(OvFormContext)

  const blocker = useBlocker(
    useCallback(() => {
      // Don't block if navigation is explicitly allowed (check ref for most current value)
      if (allowNavigationRef?.current) {
        return false
      }
      // Check formState.isDirty directly instead of memoized value
      return formState.isDirty
    }, [formState, allowNavigationRef])
  )

  useEffect(() => {
    if (blocker.state === 'blocked') {
      ui.confirm({
        title: 'Wijzigingen niet opgeslagen',
        content: 'Je hebt onopgeslagen wijzigingen. Als je nu weggaat, gaan deze verloren. Weet je het zeker?',
        withCancel: true,
      })
        .then(() => {
          // User confirmed - proceed with navigation
          blocker.proceed?.()
        })
        .catch(() => {
          // User cancelled - reset blocker
          blocker.reset?.()
        })
    }
  }, [blocker, ui])

  useBeforeUnload(
    useCallback(
      event => {
        if (formState.isDirty && !allowNavigationRef?.current) {
          event.preventDefault()
          event.returnValue = 'De wijzigingen worden niet opgeslagen, weet je het zeker?'
        }
      },
      [formState, allowNavigationRef]
    ),
    { capture: true }
  )

  return <>{children}</>
})
